module.exports = __webpack_public_path__ + "img/2020_11_17_squid_head.64cafebb.jpg";